import { atom } from 'recoil';
import { EvidenceMedia } from '../types/evidences';

export const evidenceMediaState = atom<EvidenceMedia | undefined>({
  key: 'app.evidence.media',
  default: undefined,
});
